/** Search parameters used in the profile page. */
export const searchParametersProfile = {
    DESCRIPTION: 'description',
    MANAGERS: 'managers',
    NAME: 'name',
}

/** Search parameters used in the profile API. */
export const searchParametersProfileApi = {
    DESCRIPTION: 'description__icontains',
    MANAGERS: 'client__id__in',
    NAME: 'name__icontains',
}
